import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Provider } from 'react-redux';
import store from './redux/store'; 
import Routing from './Routing/routing';

ReactDOM.render(
  <Provider store={store}>
    <Routing/>
  </Provider>,
  document.getElementById('root')
  
);
